import * as React from 'react'
import styles from './style.module.css';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Schedule from '../../Schedule';
import { useLocalServices } from '../../../../../../../hooks';
import { Edit_Travel_Operate_Changed, Edit_Travel_set_pickup, Set_Pickup_Inputs } from '../../../../../../../Redux/actions/actionNames';
import { ARROW_DOWN, CLOSE } from '../../../../../../../assets';
import Typography from '../../../../../../../design-system/lib/Typography';
import Input from '../../../../../../../design-system/lib/Input';
import Button from '../../../../../../../design-system/lib/Button';
import PhoneInput from '@onro/react-phone-input-2'
import '@onro/react-phone-input-2/lib/style.css'
import IconProvider from '../../../../../../../design-system/lib/IconProvider';
import Address_details_Icon from '../../../../../../../assets/IconProvider/address_details_color.svg'
import ArrowDown from '../../../../../../../assets/IconProvider/Arrow---Down-2.svg'
import address_details from '../../../../../../../assets/IconProvider/address_details.svg'
import email_x from '../../../../../../../assets/IconProvider/email_x.svg'
import notes_X from '../../../../../../../assets/IconProvider/notes_X.svg'
import person_x from '../../../../../../../assets/IconProvider/person_x.svg'



function PickupInfoEditOrder({ handleShowInfo, pickupRequiredCheck }) {
  const serviceId = useSelector((state) => state.ViewTravel.pureData.service.id)
  const serviceactiveVehicleType = useSelector((state) => state.EditOrder.editOrder.service.activeVehicleType)

  const addressDetail = useSelector((state) => state.EditOrder.editOrder.pickup.addressDetail)
  const floor = useSelector((state) => state.EditOrder.editOrder.pickup.floor)
  const unit = useSelector((state) => state.EditOrder.editOrder.pickup.room)
  const email = useSelector((state) => state.EditOrder.editOrder.pickup.email)
  const senderFullName = useSelector((state) => state.EditOrder.editOrder.pickup.fullName)
  const senderPhoneNumber = useSelector((state) => state.EditOrder.editOrder.pickup.phone)
  const ActivescheduleSetting = useSelector((state) => state.ViewTravel.pureData?.deliveryMethod?.scheduleSetting?.isActive)
  const deliveryMethod = useSelector((state) => state.ViewTravel.pureData?.deliveryMethod)

  const scheduleDateBefore = useSelector((state) => state.EditOrder.editOrder.pickup.scheduleDateBefore)
  const scheduleDateAfter = useSelector((state) => state.EditOrder.editOrder.pickup.scheduleDateAfter)
  const orderTypeActive = useSelector((state) => state.ViewTravel.pureData.type)
  const block = useSelector((state) => state.EditOrder.editOrder.pickup.buildingBlock)
  const noteForDriver = useSelector((state) => state.EditOrder.editOrder.pickup.customerDescription)

  const [collapsed, setCollapsed] = React.useState(true);

  const { t, i18n } = useTranslation();


  const dispatch = useDispatch();


  const closeDialoge = () => {
    handleShowInfo()
  };


  const Emailvalidate = (email) => {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }


  const handlePickUpInputs = (e, name) => {
    dispatch(Edit_Travel_Operate_Changed());

    dispatch(
      Edit_Travel_set_pickup({
        [name]: e.target.value ? e.target.value : "",
      })
    );


  };

  const phoneNumberOnChange = (res, id) => {
    dispatch(Edit_Travel_Operate_Changed());

    dispatch(
      Edit_Travel_set_pickup({
        [id]: res
      })
    );
  };

  const detectOrderType = React.useCallback(() => {

    if (serviceactiveVehicleType && serviceactiveVehicleType.orderTypes?.indexOf("PickupDelivery") > -1) {
      return "PickupDelivery"
    } else {
      return "Ondemand"
    }

  }, [serviceactiveVehicleType])



  const GetDetailsInputtoText = React.useCallback(() => {

    let xxx = ""

    if (addressDetail && String(addressDetail).trim().length > 0 && (serviceactiveVehicleType?.setting?.isAddressDetailsActive && detectOrderType() == "PickupDelivery")) {
      String(xxx).length > 0 ? xxx += `, ${addressDetail}` : xxx += `${addressDetail}`;
    }

    if (block && String(block).trim().length > 0) {
      String(xxx).length > 0 ? xxx += `, ${block}` : xxx += `${block}`
    }

    if (floor && String(floor).trim().length > 0) {
      String(xxx).length > 0 ? xxx += `, ${floor}` : xxx += `${floor}`
    }

    if (unit && String(unit).trim().length > 0) {
      String(xxx).length > 0 ? xxx += `, ${unit}` : xxx += `${unit}`
    }

    if (email && String(email).trim().length > 0) {
      String(xxx).length > 0 ? xxx += `, ${email}` : xxx += `${email}`
    }


    if (senderFullName && String(senderFullName).trim().length > 0) {
      String(xxx).length > 0 ? xxx += `, ${senderFullName}` : xxx += `${senderFullName}`
    }


    if (senderPhoneNumber && String(senderPhoneNumber).trim().length > 0) {
      String(xxx).length > 0 ? xxx += `, ${senderPhoneNumber}` : xxx += `${senderPhoneNumber}`
    }



    if (noteForDriver && String(noteForDriver).trim().length > 0) {
      String(xxx).length > 0 ? xxx += `, ${noteForDriver}` : xxx += `${noteForDriver}`
    }

    return xxx

  }, [addressDetail, block, floor, unit, email, senderFullName, senderPhoneNumber, noteForDriver, serviceactiveVehicleType])




  return (
    <div className={styles.NewCustomerRegisterContainer} >
      <div className={styles.collapseHeaderContainer} onClick={() => { setCollapsed(!collapsed) }}>

        <IconProvider Icon={Address_details_Icon} size='14' style={{ marginInlineStart: "11.6px" }} />
        <Typography text={<>{t("Details")}{(String(GetDetailsInputtoText()).length > 0 && !collapsed) ? ":" : ""} {!pickupRequiredCheck && <span className={styles.starRequired} style={{ color: "red" }}>*</span>} </>} weight="Body_Middle_Medium" style={{ marginInlineStart: "4px" }} />
        {!collapsed && <Typography text={GetDetailsInputtoText()} weight="Body_Tiny_Regular" style={{ marginInlineStart: "4px", textDecoration: 'none', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', width: 'auto', flex: '1' }} />}


        <IconProvider Icon={ArrowDown} size='10' style={{ marginInlineStart: "auto", marginInlineEnd: "10px", transform: collapsed ? "" : "rotate(180deg)" }} />
      </div>
      {/* 
      {orderTypeActive == "PickupDelivery" && <div className={styles.body}>
        <PickupDriverNewOrder />
      </div>} */}

      {(!pickupRequiredCheck && !collapsed) && <Typography text={t("CompleteRequiredFeileds")} weight='Body_Small_Regular' style={{
        width: "345px", overflow: 'hidden',
        textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: "1", marginTop: "6px"
      }} textColor='Red' />}


      {collapsed && <div className={styles.body}>

        <div className={styles.inputsConatiner}>
          {(deliveryMethod?.setting?.isPickupAddressRoomFloorBlockActive && orderTypeActive != "PickupDelivery") && <div className={styles.threeCOLUMNS}>
            <Input type={"text"} placeHolder={t("block")} value={block} inputStyle={{ width: "inherit" }} onChange={(e) => { handlePickUpInputs(e, "buildingBlock") }} />
            <Input type={"text"} placeHolder={t("Floor")} value={floor} inputStyle={{ width: "inherit" }} onChange={(e) => { handlePickUpInputs(e, "floor") }} />
            <Input type={"text"} placeHolder={t("Unit")} value={unit} inputStyle={{ width: "inherit" }} onChange={(e) => { handlePickUpInputs(e, "room") }} />
          </div>}

          {(deliveryMethod?.setting?.isAddressDetailsActive && orderTypeActive == "PickupDelivery") &&
            <Input type={"text"} iconStart={address_details} placeHolder={t("addressDetail")} value={addressDetail} inputStyle={{ width: "inherit" }} onChange={(e) => { handlePickUpInputs(e, "addressDetail") }} />
          }
{(deliveryMethod?.setting?.isDropoffAddressNameActive || deliveryMethod?.setting?.isPickupAddressEmailActive) && <div className={styles.twoColumnContainer}>

          {deliveryMethod?.setting?.isPickupAddressNameActive && <Input iconStart={person_x} isRequired={deliveryMethod?.setting?.isPickupAddressNameRequired} isRequiredText={t("*")} type={"text"} placeHolder={t("Fullname")} value={senderFullName} onChange={(e) => { handlePickUpInputs(e, "fullName") }} />}

        {(deliveryMethod?.setting?.isPickupAddressEmailActive) && <Input iconStart={email_x} isRequired={deliveryMethod?.setting?.isPickupAddressEmailRequired} isRequiredText={t("*")} error={Emailvalidate(email) ? "" : t("Emailisnotcorrect")} type={"text"} value={email} placeHolder={t("email")} onChange={(e) => { handlePickUpInputs(e, "email") }} />}

     




          </div>}

           {deliveryMethod?.setting?.isPickupAddressPhoneActive &&

 
            <div className={styles.PhoneInput}>

              <PhoneInput
                countryCodeEditable={false}
                country={String(global.config.countryCca2).toLowerCase()}
                    className={clsx(styles.inputContainer, "newUi_senderphonenumberPickup")}
                value={senderPhoneNumber}
                onChange={(e1, e2, e3, e4) => { phoneNumberOnChange(e4, "phone") }}
                enableLongNumbers={true}
                inputProps={{ type: "text" }}
                copyNumbersOnly={false}
                autoFormat={false}
                placeHolder={t("Phonenumber")}

              />
              {/* <PhoneInput
               defaultCountry={global.config. countryCca2}
               placeholder={t("Phonenumber")}
               value={senderPhoneNumber}
               onChange={(PrePhoneInput) => {
                 phoneNumberOnChange(PrePhoneInput, "phone")
               }
               }
               className={clsx(styles.inputContainer, "senderphonenumberPickup")}
             /> */}
              {deliveryMethod &&
                deliveryMethod.setting &&
                deliveryMethod.setting.isPickupAddressPhoneRequired && (senderPhoneNumber ? String(senderPhoneNumber).trim().length == 0 : true) && (
                  <span className={`inputRequired ${styles.PhoneInputRequired}`}>
                    {t("*")}
                  </span>
                )}
            </div>
          }

          {orderTypeActive != "PickupDelivery" && <Input type={"text"} iconStart={notes_X} value={noteForDriver} placeHolder={t("notesfordriver")} onChange={(e) => { handlePickUpInputs(e, "customerDescription") }} />}


        </div>

      </div>}



    </div>
  )
}

export default PickupInfoEditOrder